import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import WhatsAppButton from "@/components/WhatsAppButton";
import CookieConsent from "@/components/CookieConsent";
import HomePage from "@/pages/HomePage";
import AannemerPage from "@/pages/AannemerPage";
import BadkamerPage from "@/pages/BadkamerPage";
import StukadoorPage from "@/pages/StukadoorPage";
import SchilderwerkPage from "@/pages/SchilderwerkPage";
import TimmerwerkPage from "@/pages/TimmerwerkPage";
import ContactPage from "@/pages/ContactPage";
import CompleteRenovatiePage from "@/pages/CompleteRenovatiePage";
import UurtariefPage from "@/pages/UurtariefPage";
import AdminPage from "@/pages/AdminPage";
import PrivacyPage from "@/pages/PrivacyPage";
import NotFoundPage from "@/pages/NotFoundPage";

function Layout({ children }) {
  const location = useLocation();
  const isAdminPage = location.pathname === "/admin";
  
  if (isAdminPage) {
    return children;
  }
  
  return (
    <div className="min-h-screen flex flex-col">
      <Navbar />
      <main className="flex-1">{children}</main>
      <Footer />
      <WhatsAppButton />
      <CookieConsent />
    </div>
  );
}

function App() {
  return (
    <BrowserRouter>
      <Layout>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/aannemer" element={<AannemerPage />} />
          <Route path="/badkamer-renovatie" element={<BadkamerPage />} />
          <Route path="/stukadoor" element={<StukadoorPage />} />
          <Route path="/schilderwerk" element={<SchilderwerkPage />} />
          <Route path="/timmerwerk" element={<TimmerwerkPage />} />
          <Route path="/complete-renovatie" element={<CompleteRenovatiePage />} />
          <Route path="/uurtarief" element={<UurtariefPage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/privacy" element={<PrivacyPage />} />
          <Route path="/admin" element={<AdminPage />} />
          <Route path="*" element={<NotFoundPage />} />
        </Routes>
      </Layout>
      <Toaster position="top-right" richColors />
    </BrowserRouter>
  );
}

export default App;
